'use strict';

/**
 *  Copyright (c) Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE file in the root directory of this source tree.
 */

// The primary React component to use.
module.exports = require('./components/GraphiQL').GraphiQL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphiql/dist/index.js
// module id = 279
// module chunks = 0